import React from "react";
import {Container} from "react-bootstrap";
import styles from "./ErrorPage.module.scss";
import LazyImage from "../../components/LazyImage/LazyImage";

const ErrorPage: React.FC = () => {
    return (
        <div className={styles.errorPage}>
            <Container className={styles.errorPageContainer}>
                <LazyImage className={styles.errorPageLogo}
                           src="./assets/images/logos/alfaLogo2.svg"
                           alt="Страница не найдена"
                />
                <div className={styles.errorPageImageWrap}>
                    <LazyImage className={styles.errorPageImage}
                               src="./assets/images/general/error404.png"
                               alt="Страница не найдена"
                    />
                    <h1 className={styles.errorPageTitle}>
                        Страница не найдена
                    </h1>
                </div>
            </Container>
        </div>
    )
}
export default ErrorPage;